import { useContext } from "react"
import type { EditMode } from "src/components"
import type { EditStageContextProps } from "./EditStageContext"
import { EditStageContext } from "./EditStageContext"

export const useEditStageContext = <T extends string>() => {
	const context = useContext(EditStageContext)
	if (context === undefined) {
		throw new Error("EditStageContext is required for this component")
	}

	return context as unknown as EditStageContextProps<T>
}
export type EditStageContextPropsWithEditMode<T extends string> = EditStageContextProps<T> & { mode: EditMode }

export const useEditStageContextForStage = <T extends string = string>(
	stageId: T,
): EditStageContextPropsWithEditMode<T> => {
	const context = useEditStageContext<T>()

	const mode = context.editStage === undefined ? "view" : context.editStage === stageId ? "edit" : "readOnly"

	return {
		...context,
		mode,
	}
}
